import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/skrining-gizi-lanjut", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/skrining-gizi-lanjut/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(
  register_id: string | number,
  params: {
    page: number;
    per_page: number;
    sort_by: string;
    sort_desc: boolean;
  } = null
) {
  const response = await http
    .getDataParam(
      `/register/${register_id}/skrining-gizi-lanjut`,
      params
        ? {
            params: params
          }
        : null
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number) {
  const response = await http.getData(`/skrining-gizi-lanjut/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/skrining-gizi-lanjut/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/skrining-gizi-lanjut/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  print
};
